import { memo, useCallback } from 'react'
import replaceBrowserHistory from '@pancakeswap/utils/replaceBrowserHistory'
import { useTranslation } from '@pancakeswap/localization'
import { ArrowDownIcon } from '@radix-ui/react-icons'
import { useSwapActionHandlers } from '@/state/swap/useSwapActionHandlers'
import { useSwapState } from '@/state/swap/hooks'
import { Field } from '@/state/swap/actions'
import { useAllowRecipient } from '../hooks'

export const FlipButton = memo(function FlipButton() {
  const { t } = useTranslation()
  const { onSwitchTokens, onChangeRecipient } = useSwapActionHandlers()
  const {
    recipient,
    [Field.INPUT]: { currencyId: inputCurrencyId },
    [Field.OUTPUT]: { currencyId: outputCurrencyId },
  } = useSwapState()
  const allowRecipient = useAllowRecipient()

  const onFlip = useCallback(() => {
    onSwitchTokens()
    replaceBrowserHistory('inputCurrency', outputCurrencyId)
    replaceBrowserHistory('outputCurrency', inputCurrencyId)
  }, [onSwitchTokens, inputCurrencyId, outputCurrencyId])

  return (
    <div>
      <div
        className={
          'w-13 h-13 rounded-2xl flex items-center justify-center border-5 border-background bg-secondary cursor-pointer'
        }
      >
        <ArrowDownIcon onClick={onFlip} className={'w-6 h-6 font-bold text-muted-foreground'} />
      </div>
    </div>
  )
})
